window.addEventListener("popstate", function(e) {
  if (e.state && e.state.locationReload) {
    return setTimeout(() => window.location.reload());
  }
});



// WEBPACK FOOTER //
// ./app/webpack/frontend/config/history.js